<div class="error-screen">
    <h1 class="text-center text-lg font-semibold text-gray-800">
        We encountered an unexpected issue. Please wait a few minutes and try logging in again.
        <br />
        If the problem persists, kindly contact the QEP Helpdesk for further assistance.
    </h1>
</div>
